import { QueryConfig } from "store/utils/query-config";

export const magicAssistantsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
